import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { GlobalService } from '../../../core/_infrastructure/classes/services/global.service';
import { UbicacionService } from './ubicacion.service';
import { TUbicacionViewModel } from './../puntosinspeccion/puntoinspeccion.types';
import { ComponentBase } from '../../../core/_infrastructure/classes/componentBase';
import { Tc, EnumIdsTcPais } from '../../../core/_infrastructure/types/common';
import { NotificationService } from '../../../core/_infrastructure/classes/services/notification.service';
import { ExceptionManager } from '../../../core/_infrastructure/classes/handlers/exceptionManager';
import { AuthService } from '../../../core/_infrastructure/classes/services/auth.service';

@Component({
    selector: 'app-ubicacion-edit',
    templateUrl: './ubicacion-edit.component.html',
})
export class UbicacionEditComponent extends ComponentBase implements OnInit {
    editMode: boolean;
    editTitle: string = 'Nueva';

    listPuntoInspeccion: Tc[];

    ubicacion: TUbicacionViewModel;

    constructor(
        private activatedRoute: ActivatedRoute,
        private router: Router,
        private fb: UntypedFormBuilder,
        private globalService: GlobalService,
        private ubicacionControlService: UbicacionService,
        protected notificationService: NotificationService,
        protected authService: AuthService,
        protected exceptionHandler: ExceptionManager,
    ) {
        super(authService, notificationService, exceptionHandler);
        this.ubicacion = new TUbicacionViewModel();
    }

    ngOnInit() {
        this.createForm();

        let id = +this.activatedRoute.snapshot.params['id'];

        if (id) {
            this.editMode = true;
            this.editTitle = 'Editar';

            this.ubicacionControlService.getUbicacion(id).subscribe(result => {
                this.ubicacion = result;
                this.updateForm();
            });
        }

        this.globalService.getPuntoInspeccionByPais(EnumIdsTcPais.ID_ESPANA).subscribe(res => {
            this.listPuntoInspeccion = res;
        });

        this.form.get('IdPuntoInspeccion')?.valueChanges.subscribe(() => {
            this.form.get('Descripcion')?.updateValueAndValidity();
        });
    }

    createForm() {
        this.form = this.fb.group({
            Descripcion: ['', Validators.required],
            IdPuntoInspeccion: [null, Validators.required],
            HabilitadaImportacion: true,
            HabilitadaExportacion: true,
            PorDefecto: true,
        });
    }

    updateForm() {
        this.form.setValue({
            Descripcion: this.ubicacion.Descripcion,
            IdPuntoInspeccion: this.ubicacion.IdPuntoInspeccion,
            HabilitadaImportacion: this.ubicacion.HabilitadaImportacion,
            HabilitadaExportacion: this.ubicacion.HabilitadaExportacion,
            PorDefecto: this.ubicacion.PorDefecto,
        });
    }

    onSubmit() {
        this.submitted = true;

        if (!this.form.valid) {
            this.addErrorMessage('Revise los datos');
            return;
        }

        let ubicacion = new TUbicacionViewModel();

        ubicacion.Descripcion = this.form.value.Descripcion;
        ubicacion.IdPuntoInspeccion = this.form.value.IdPuntoInspeccion;
        ubicacion.HabilitadaImportacion = this.form.value.HabilitadaImportacion;
        ubicacion.HabilitadaExportacion = this.form.value.HabilitadaExportacion;
        ubicacion.PorDefecto = this.form.value.PorDefecto;

        ubicacion.Id = this.ubicacion.Id;

        if (this.editMode) {
            this.ubicacionControlService.editUbicacion(ubicacion).subscribe({
                next: res => {
                    this.addSuccessMessage('Ubicación modificada correctamente');
                    this.onBack();
                },
                error: error => this.catchServerError(error),
            });
        } else {
            this.ubicacionControlService.createUbicacion(ubicacion).subscribe({
                next: res => {
                    this.addSuccessMessage('Ubicación añadida correctamente');
                    this.onBack();
                },
                error: error => this.catchServerError(error),
            });
        }
    }

    onBack() {
        this.router.navigate(['/mantenimiento/general/ubicaciones']);
    }
}
